module.exports = __webpack_public_path__ + "img/happy-smiley.4af4ed2d.svg";